import { ServiceType } from '@rover/constants/src/translations/service.constants';
import { PetTypeEnum } from '@rover/rsdk/src/apiClient/latest/model/petTypeEnum';

/**
 * The value prop filters available on a page are driven by the page's internal
 * service type and (for overnight boarding) its pet type. See DEV spec for the
 * per-service/per-pet matrix.
 */
export enum ValuePropFilter {
  NoCat = 'no-cat',
  NoDog = 'no-dog',
  FencedYard = 'fenced-yard',
  NotFixed = 'not-fixed',
  OnlyOnePet = 'only-one-pet',
  Puppies = 'puppies',
}

export const BOARDING_DOG_FILTERS = [
  ValuePropFilter.NoCat,
  ValuePropFilter.NoDog,
  ValuePropFilter.FencedYard,
  ValuePropFilter.NotFixed,
  ValuePropFilter.OnlyOnePet,
  ValuePropFilter.Puppies,
];

export const BOARDING_CAT_FILTERS = [
  ValuePropFilter.NoCat,
  ValuePropFilter.NoDog,
  ValuePropFilter.NotFixed,
  ValuePropFilter.OnlyOnePet,
];

export const DOG_TRAVELING_OR_DROP_IN_FILTERS = [ValuePropFilter.NotFixed, ValuePropFilter.Puppies];
export const CAT_TRAVELING_OR_DROP_IN_FILTERS = [ValuePropFilter.NotFixed];

export const DOG_WALKING_FILTERS = [
  ValuePropFilter.NotFixed,
  ValuePropFilter.OnlyOnePet,
  ValuePropFilter.Puppies,
];

// Doggy day care surfaces the same full set of filters as dog boarding.
export const DAY_CARE_FILTERS = BOARDING_DOG_FILTERS;

export const getValuePropFilters = (
  internalServiceTypeSlug: string,
  petType?: PetTypeEnum | null
): ValuePropFilter[] => {
  switch (internalServiceTypeSlug) {
    case ServiceType.OVERNIGHT_BOARDING:
      return petType === PetTypeEnum.cat ? BOARDING_CAT_FILTERS : BOARDING_DOG_FILTERS;
    case ServiceType.OVERNIGHT_TRAVELING:
    case ServiceType.DROP_IN:
      return petType === PetTypeEnum.cat
        ? CAT_TRAVELING_OR_DROP_IN_FILTERS
        : DOG_TRAVELING_OR_DROP_IN_FILTERS;
    case ServiceType.DOG_WALKING:
      return DOG_WALKING_FILTERS;
    case ServiceType.DOGGY_DAY_CARE:
      return DAY_CARE_FILTERS;
    default:
      return [];
  }
};
